import api from '~/services/api';

export async function acceptTerms(contrato_id) {
  const response = await api.put(`/contrato/${contrato_id}/accept`);
  return response.data;
}
